import React, { Component } from 'react';
import { Route } from 'react-router';
import { AppBody } from './components/AppBody';
import Home from './components/Home';
import { FetchData } from './components/FetchData';
//import Route from './components/api-authorization/Route';
//import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Login } from './components/auth/Login';
import Session from './components/auth/Session';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { Roles } from './components/admin/Roles';
import { CreateRole } from './components/admin/CreateRole';
import { AccessDenied } from './components/util/AccessDenied';
import './custom.css'
import { Users } from './components/admin/Users';
import { Clients } from './components/admin/Clients';
import { RoleDetails } from './components/admin/RoleDetails';
import { UserDetails } from './components/admin/UserDetails';
import { CreateClient } from './components/admin/CreateClient';
import { ClientDetails } from './components/admin/ClientDetails';
import { Admin } from './components/admin/Admin';
//import { Login } from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import { Dashboard } from './components/dataEntryWorkers/Dashboard';
import { useChatWidgetScripts } from './hooks/useChatWidgetScripts';
import ChatWidgetLoader from './components/ChatWidgetLoader';
import FindQuote from './components/FindQuote';
import { CheckEligibility } from './components/signup/CheckEligibility';
import { FormProvider } from './context/FormContext';
import { DataPointSelection } from './components/signup/DataPointSelection';
import { NotEligible } from './components/signup/NotEligible';
import { ConfirmDetails } from './components/signup/ConfirmDetails';
import { AdditionalParty } from './components/signup/AdditionalParty';
import { FinalizePolicy } from './components/signup/FinalizePolicy';
import { SignApplication } from './components/signup/SignApplication';
import { PaymentMethod } from './components/signup/payment/PaymentMethod';
import { BankDetails } from './components/signup/payment/BankDetails';
import { CardDetails } from './components/signup/payment/CardDetails';
import { ReviewPayment } from './components/signup/payment/ReviewPayment';
import { ProcessingPayment } from './components/signup/payment/ProcessingPayment';
import { PolicySecured } from './components/signup/Complete';
import { UserDashboard } from './components/UserDashboard';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminCSRRoute } from './components/AdminCSRRoute';
import { AdminRoute } from './components/AdminRoute';
import QuoteDashboard from './components/QuoteDashboard';
import { ContinueQuote } from './components/ContinueQuote';


export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <AppBody>
                <ChatWidgetLoader />
                <FormProvider>
                    <Route exact path='/' component={Home} />
                    <Route path='/home' component={Home} />
                    <Route path="/signup/eligibility" component={CheckEligibility} />
                    <ProtectedRoute path="/signup/data-points" component={DataPointSelection} />
                    <ProtectedRoute path="/signup/not-eligible" component={NotEligible} />
                    <ProtectedRoute path="/signup/confirm-details" component={ConfirmDetails} />
                    <ProtectedRoute path="/signup/additional-party" component={AdditionalParty} />
                    <ProtectedRoute path="/signup/finalize" component={FinalizePolicy} />
                    <ProtectedRoute path="/signup/sign" component={SignApplication} />
                    <ProtectedRoute path="/signup/payment" exact component={PaymentMethod} />
                    <ProtectedRoute path="/signup/payment/bank" component={BankDetails} />
                    <ProtectedRoute path="/signup/payment/card" component={CardDetails} />
                    <ProtectedRoute path="/signup/payment/review" component={ReviewPayment} />
                    <ProtectedRoute path="/signup/payment/processing" component={ProcessingPayment} />
                    <ProtectedRoute path="/signup/complete" component={PolicySecured} />
                    <ProtectedRoute path="/dashboard" component={UserDashboard} />
                    <AdminCSRRoute path="/data/dashboard" component={QuoteDashboard} />
                    <Route path="/continue-quote" component={ContinueQuote}/>
                </FormProvider>

                <Route path='/find-quote'  component={FindQuote} />


                {/* <Route path='/login' component={Login} /> */}
                <Route path='/forgot-password' component={ForgotPassword} />
                <Route path='/reset-password' component={ResetPassword} />
                <Route path='/fetch-data' component={FetchData} />

                {/* <Route exact path='/admin' component={Admin} />
                <Route exact path='/admin/roles' component={Roles} />
                <Route exact path='/admin/roles/create' component={CreateRole} />
                <Route exact path='/admin/roles/details' component={RoleDetails} />
                <Route exact path='/admin/users' component={Users} />
                <Route exact path='/admin/users/details' component={UserDetails} />
                <Route exact path='/admin/clients' component={Clients} />
                <Route exact path='/admin/clients/create' component={CreateClient} />
                <Route exact path='/admin/clients/details' component={ClientDetails} /> */}


                {/* <Route exact path='/admin/roles' component={Roles} />
                <Route exact path='/admin/roles/create' component={CreateRole} />
                <Route exact path='/admin/roles/details' component={RoleDetails} />
                <Route exact path='/admin/users' component={Users} />
                <Route exact path='/admin/users/details' component={UserDetails} /> */}

                <AdminRoute exact path='/admin/users' component={Users} />
                <AdminRoute exact path='/admin/users/details' component={UserDetails} />


                {/*<Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />*/}
                <Route exact path='/login' component={Login} />
                <Route exact path='/logout' render={() => {
                    Session.removeUserSession();
                    window.location.href = '/login';
                    return <></>;
                }} />
                {/* <Route exact path='/forgot' render={() => {
                    window.location.href = '/Identity/Account/ForgotPassword';
                    return <></>;
                }} /> */}
                <Route exact path='/accessdenied' component={AccessDenied} />
            </AppBody>
        );
    }
}